import { useQuery } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { mapCreatorFromApiModelToViewModel } from '~/clientApi/clientApi.mapper';
import { CREATOR_ENTITY_QUERY_KEY } from '~/queries/keys';

export function useDefaultSelectedCreator(
  creatorId: string | undefined,
  onError?: () => void,
) {
  return useQuery({
    queryKey: [CREATOR_ENTITY_QUERY_KEY, creatorId],
    queryFn: () =>
      clientApi.creators
        .read({ id: creatorId })
        .then(mapCreatorFromApiModelToViewModel),
    enabled: Boolean(creatorId),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 2,
    onError: () => {
      onError?.();
    },
  });
}
